import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute, PublicRoute } from '@/components/ProtectedRoute.tsx';
import { ProtectedLayout } from '@/components/layout';
import { DashboardPage } from '@/pages/DashboardPage.tsx';
import { ActivityPage } from '@/pages/ActivityPage.tsx';
import { AlertsPage } from '@/pages/AlertsPage.tsx';
import { PrintersPage } from '@/pages/PrintersPage.tsx';
import { PrinterDetailPage } from '@/pages/PrinterDetailPage.tsx';
import { PrinterLibraryDetailPage } from '@/pages/PrinterLibraryDetailPage.tsx';
import { FilamentSystemsPage } from '@/pages/FilamentSystemsPage.tsx';
import { FilamentsPage } from '@/pages/FilamentsPage.tsx';
import { SpoolsPage } from '@/pages/SpoolsPage.tsx';
import { StorageLocationsPage } from '@/pages/StorageLocationsPage.tsx';
import { HotendsPage } from '@/pages/HotendsPage.tsx';
import { NozzlesPage } from '@/pages/NozzlesPage.tsx';
import { BuildPlatesPage } from '@/pages/BuildPlatesPage.tsx';
import { ConsumablesPage } from '@/pages/ConsumablesPage.tsx';
import { ToolsPage } from '@/pages/ToolsPage.tsx';
import { OtherAccessoriesPage } from '@/pages/OtherAccessoriesPage.tsx';
import { ProjectsPage } from '@/pages/ProjectsPage.tsx';
import { JobsPage } from '@/pages/JobsPage.tsx';
import { JobDetailPage } from '@/pages/JobDetailPage.tsx';
import { QueuePage } from '@/pages/QueuePage.tsx';
import { ModelsPage } from '@/pages/ModelsPage.tsx';
import { ModelDetailPage } from '@/pages/ModelDetailPage.tsx';
import { ModelFileViewerPage } from '@/pages/ModelFileViewerPage.tsx';
import { ModelFileDetailPage } from '@/pages/ModelFileDetailPage.tsx';
import { CollectionsPage } from '@/pages/CollectionsPage.tsx';
import { CollectionDetailPage } from '@/pages/CollectionDetailPage.tsx';
import { LoginPage } from '@/pages/LoginPage.tsx';
import { RegisterPage } from '@/pages/RegisterPage.tsx';
import { AuthCallbackPage } from '@/pages/AuthCallbackPage.tsx';
import { OnboardingPage } from '@/pages/OnboardingPage.tsx';
import { ProfilePage } from '@/pages/settings/ProfilePage.tsx';
import { NotificationsPage } from '@/pages/settings/NotificationsPage.tsx';
import { PrivacyPage } from '@/pages/settings/PrivacyPage.tsx';
import { WorkspacePage } from '@/pages/settings/WorkspacePage.tsx';
import { TeamPage } from '@/pages/settings/TeamPage.tsx';
import { SubscriptionPage } from '@/pages/settings/SubscriptionPage.tsx';
import { IntegrationsPage } from '@/pages/settings/IntegrationsPage.tsx';
import { NotFoundPage } from '@/pages/NotFoundPage.tsx';

export function App() {
  // Auth initialization is handled by useAuth hook in ProtectedRoute/ProtectedLayout
  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <RegisterPage />
          </PublicRoute>
        }
      />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/auth/error" element={<AuthCallbackPage />} />

      {/* Protected routes with AppShell - using layout route pattern */}
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/activity" element={<ActivityPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/printers/library/:id" element={<PrinterLibraryDetailPage />} />
        <Route path="/printers/:id" element={<PrinterDetailPage />} />
        <Route path="/printers" element={<PrintersPage />} />
        <Route path="/printers/filament-systems" element={<FilamentSystemsPage />} />
        <Route path="/filaments" element={<FilamentsPage />} />
        <Route path="/spools" element={<SpoolsPage />} />
        <Route path="/storage" element={<StorageLocationsPage />} />
        <Route path="/accessories/hotends" element={<HotendsPage />} />
        <Route path="/accessories/nozzles" element={<NozzlesPage />} />
        <Route path="/accessories/build-plates" element={<BuildPlatesPage />} />
        <Route path="/accessories/consumables" element={<ConsumablesPage />} />
        <Route path="/accessories/tools" element={<ToolsPage />} />
        <Route path="/accessories/other" element={<OtherAccessoriesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/jobs/:id" element={<JobDetailPage />} />
        <Route path="/projects/jobs" element={<JobsPage />} />
        <Route path="/projects/queue" element={<QueuePage />} />
        <Route path="/models/:modelId/files/:fileId/details" element={<ModelFileDetailPage />} />
        <Route path="/models/:modelId/files/:fileId" element={<ModelFileViewerPage />} />
        <Route path="/models/:id" element={<ModelDetailPage />} />
        <Route path="/models" element={<ModelsPage />} />
        <Route path="/collections/:id" element={<CollectionDetailPage />} />
        <Route path="/collections" element={<CollectionsPage />} />
        <Route path="/settings/profile" element={<ProfilePage />} />
        <Route path="/settings/notifications" element={<NotificationsPage />} />
        <Route path="/settings/privacy" element={<PrivacyPage />} />
        <Route path="/settings/workspace" element={<WorkspacePage />} />
        <Route path="/settings/team" element={<TeamPage />} />
        <Route path="/settings/subscription" element={<SubscriptionPage />} />
        <Route path="/settings/integrations" element={<IntegrationsPage />} />
      </Route>
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <OnboardingPage />
          </ProtectedRoute>
        }
      />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
